import React from "react";
import "./GdprCompliance.css"; // Make sure this matches your CSS file name

function GdprCompliance() {
  return (
    <div className="diligencia-gdpr-container">
      {/* Hero Header Banner */}
      <header className="gdpr-hero">
        <div className="gdpr-hero-overlay"></div>
        <div className="gdpr-hero-content">
          <div className="gdpr-badge">Compliance Statement</div>
          <h1>General Data Protection Regulation</h1>
          <p className="gdpr-lead">
            Diligencia Solutions &amp; Services Pvt. Ltd. recognizes the
            importance of protecting personal data and is deeply committed to
            upholding the principles of the GDPR framework.
          </p>
        </div>
      </header>
      <div className="container">
        {/* Main Content Layout */}
        <div className="gdpr-content-wrapper ">
          {/* Section 1: Our Commitments Grid */}
          <section className="gdpr-section">
            <div className="section-header">
              <h2>Our Core Commitments</h2>
              <div className="header-line"></div>
              <p>
                How we systematically ensure data protection across all our
                processing streams.
              </p>
            </div>

            <div className="commitments-grid">
              <div className="commitment-card">
                <div className="card-icon">
                  <i className="fa-solid fa-scale-balanced"></i>
                </div>
                <h3>Lawfulness, Fairness &amp; Transparency</h3>
                <p>
                  We process all personal datasets strictly through legal
                  methods, with full clarity and transparency provided to the
                  data owner.
                </p>
              </div>

              <div className="commitment-card">
                <div className="card-icon">
                  <i className="fa-solid fa-bullseye"></i>
                </div>
                <h3>Purpose Limitation</h3>
                <p>
                  Personal data is strictly collected for specific, explicitly
                  stated legitimate business goals and is not processed beyond
                  that scope.
                </p>
              </div>

              <div className="commitment-card">
                <div className="card-icon">
                  <i className="fa-solid fa-compress"></i>
                </div>
                <h3>Data Minimization</h3>
                <p>
                  We intentionally limit our data intake pipelines to capture
                  only the minimal information absolutely required to deliver
                  our core services.
                </p>
              </div>

              <div className="commitment-card">
                <div className="card-icon">
                  <i className="fa-solid fa-circle-check"></i>
                </div>
                <h3>Accuracy Standards</h3>
                <p>
                  We take active operational measures to routinely audit,
                  correct, and maintain accurate, up-to-date information
                  channels.
                </p>
              </div>

              <div className="commitment-card">
                <div className="card-icon">
                  <i className="fa-solid fa-clock-rotate-left"></i>
                </div>
                <h3>Storage Limitation</h3>
                <p>
                  Data records are preserved safely only for the exact period
                  required to satisfy primary functional operations or legal
                  mandates.
                </p>
              </div>

              <div className="commitment-card">
                <div className="card-icon">
                  <i className="fa-solid fa-shield-halved"></i>
                </div>
                <h3>Integrity &amp; Confidentiality</h3>
                <p>
                  Your data is secured using advanced encryption architectures,
                  access logs, and rigid administrative access protocols.
                </p>
              </div>
            </div>
          </section>

          {/* Section 2: Split Grid for Data Subject Rights & International Clients */}
          <div className="gdpr-split-layout">
            {/* Rights Block */}
            <section className="split-block rights-block">
              <div className="block-header">
                <div className="icon-badge">
                  <i className="fa-solid fa-user-shield"></i>
                </div>
                <h2>Rights of Data Subjects</h2>
              </div>
              <p className="block-desc">
                Under GDPR provisions, individuals retain complete sovereignty
                over their data profiles and can request the following items:
              </p>

              <ul className="rights-list">
                <li>
                  <span className="bullet-num">01</span>
                  <div>
                    <strong>Access to Personal Data</strong>
                    <p>
                      Request clear digital summaries of what information we
                      hold regarding your profile.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="bullet-num">02</span>
                  <div>
                    <strong>Correction of Inaccurate Data</strong>
                    <p>
                      Incorporate immediate revisions to records that are
                      outdated, structurally wrong, or incomplete.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="bullet-num">03</span>
                  <div>
                    <strong>Deletion of Data (Right to Erasure)</strong>
                    <p>
                      Request total removal of all personal attributes from
                      active operational storage arrays.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="bullet-num">04</span>
                  <div>
                    <strong>Restriction of Processing</strong>
                    <p>
                      Temporarily suspend database analytics and active
                      processing workloads involving your specific details.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="bullet-num">05</span>
                  <div>
                    <strong>Data Portability</strong>
                    <p>
                      Export your profile information in structured, universally
                      machine-readable, clean configurations.
                    </p>
                  </div>
                </li>
                <li>
                  <span className="bullet-num">06</span>
                  <div>
                    <strong>Objection to Processing</strong>
                    <p>
                      Challenge ongoing data processing actions that lean on
                      legitimate interests or direct marketing channels.
                    </p>
                  </div>
                </li>
              </ul>
            </section>

            {/* International Security Safeguards Block */}
            <section className="split-block safeguards-block">
              <div className="sticky-safeguard-card">
                <div className="block-header">
                  <div className="icon-badge">
                    <i className="fa-solid fa-earth-americas"></i>
                  </div>
                  <h2>International Clients</h2>
                </div>
                <p>
                  We proudly provide support infrastructures to cross-border
                  enterprise frameworks located within the UK and European
                  Union.
                </p>
                <div className="safeguard-highlight">
                  <i className="fa-solid fa-lock text-green"></i>
                  <p>
                    Every engagement is fortified by Standard Contractual
                    Clauses (SCCs), data protection agreements, and end-to-end
                    organizational privacy safeguards.
                  </p>
                </div>
                <div className="compliance-stamp">
                  <div className="stamp-circle">
                    <i className="fa-solid fa-certificate"></i>
                  </div>
                  <div>
                    <h4>Fully Certified Pipelines</h4>
                    <p>
                      Data transmission across cross-border nodes meets standard
                      international protocol validation metrics.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GdprCompliance;
